import self from "../assets/img/self.png";
import mock1 from "../assets/img/mock1.png";
import mock2 from "../assets/img/mock2.png";
import mock3 from "../assets/img/mock3.png";
import mock4 from "../assets/img/mock4.png";
import mock5 from "../assets/img/mock5.png";
import mock6 from "../assets/img/mock5.png";

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

// export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
export let colors = ["rgb(167 172 174)", "rgb(167 171 174)"];
export let procolors = ["rgb(167 172 174)", "rgb(167 171 174)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
    firstName: "Praveen",
    lastName: "Kumar",
    initials: "tacqiya", // the example uses first and last, but feel free to use three or more if you like.
    position: "a Full Stack Developer",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    profileGradient: `linear-gradient(135deg, ${procolors})`, // this is for the background of the picture on the homepage. You can change it to a solid color if you don't want a gradient, but I wouldn't reccomend it! (you would have to change the css as well)
    baseColor: colors[0],
    miniBio: [
        // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
        {
            emoji: "☕",
            text: "fueled by coding",
        },
        {
            emoji: "🛹", //🌎
            text: "pumbed by skateboard",
        },
        {
            emoji: "💼",
            text: "Software Developer at Excellence Code, Dubai",
        },
        {
            emoji: "📧",
            text: "tacqiya@gmail.com",
        },
    ],
    socials: [{
            link: "https://facebook.com/praveen.kimi",
            icon: "fa fa-facebook",
            label: "facebook",
        },
        {
            link: "https://instagram.com/tacqiya",
            icon: "fa fa-instagram",
            label: "instagram",
        },
        {
            link: "https://github.com/tacqiya",
            icon: "fa fa-github",
            label: "github",
        },
        {
            link: "https://linkedin.com/praveenkimi",
            icon: "fa fa-linkedin",
            label: "linkedin",
        },
        {
            link: "https://twitter.com/tacqiya",
            icon: "fa fa-twitter",
            label: "twitter",
        },
        // Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
        // Just change the links so that they lead to your social profiles.
    ],
    bio: "Hello! I'm Praveen. I'm a web developer currently working in Dubai. I studied Computer Science & Engineering, I enjoy skateboarding, and I like to make others life automation dependable, but definitely not mine. I believe that's how a developer works. You can hire me, if you think I'm the fittest!",
    skills: {
        proficientWith: [
            "php",
            "javascript",
            "jquery",
            "react",
            "github",
            "bootstrap",
            "html5",
            "css3",
            "c++",
            "python"
        ],
        exposedTo: ["php", "nodejs", "python"],
    },
    hobbies: [{
            label: "skateboarding",
            emoji: "🛹",
        },
        {
            label: "reading",
            emoji: "📖",
        },
        {
            label: "drawing",
            emoji: "🎭",
        },
        {
            label: "movies",
            emoji: "🎥",
        },
        {
            label: "cooking",
            emoji: "🌶",
        },
        // Same as above, change the emojis to match / relate to your hobbies or interests.
        // You can also remove the emojis if you'd like, I just think they look cute :P
    ],
    portfolio: [
        // This is where your portfolio projects will be detailed
        {
            title: "PokéDex",
            live: "https://pokedex-js-iota.vercel.app/", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
            source: "https://github.com/tacqiya", // this should be a link to the **repository** of the project, where the code is hosted.
            image: mock1,
        },
        {
            title: "Movie Database",
            live: "https://movie-database-typhix.vercel.app/",
            source: "https://github.com/tacqiya",
            image: mock2,
        },
        {
            title: "Flappy Game",
            live: "https://playground-blush.vercel.app/flappy-bird",
            source: "https://github.com/tacqiya",
            image: mock3,
        },
        {
            title: "Combat Game",
            live: "https://playground-blush.vercel.app/combat-game",
            source: "https://github.com/tacqiya",
            image: mock4,
        },
        {
            title: "Password Generator",
            live: "https://playground-blush.vercel.app/password-generator",
            source: "https://github.com/tacqiya",
            image: mock5,
        },
        {
            title: "Javascript Facedetection",
            live: "https://playground-blush.vercel.app/facedetection",
            source: "https://github.com/tacqiya",
            image: mock6,
        },
        {
            title: "Weather App",
            live: "https://playground-blush.vercel.app/weather",
            source: "https://github.com/tacqiya",
            image: mock6,
        },
        {
            title: "Javascript Calculator",
            live: "https://playground-blush.vercel.app/calculator-new",
            source: "https://github.com/tacqiya",
            image: mock6,
        },
        {
            title: "Gradient Color Generator",
            live: "https://playground-blush.vercel.app/color-gradient",
            source: "https://github.com/tacqiya",
            image: mock6,
        },
        {
            title: "NextJS Chat App",
            live: "https://next-js-chat-typhix.vercel.app",
            source: "https://github.com/tacqiya",
            image: mock6,
        },
        {
            title: "Random Javascript Projects",
            live: "https://playground-blush.vercel.app",
            source: "https://github.com/tacqiya",
            image: mock6,
        },
        {
            title: "Javascript/jQuery Plugins Demo",
            live: "https://plugins-tau.vercel.app",
            source: "https://github.com/tacqiya",
            image: mock6,
        },
    ],
    experience: [
        {
            "post" : "PHP Intern",
            "date" : "OCT 2016 - DEC 2016",
            "company" : "QUEST INNOVATIVE SOLUTIONS",
            "descrition" : [
                "Learning & creating self project with server-side web application logic.",
                "Learning everything in good pace.",
                "Acquiring industrial career standards."
            ]
        },
        {
            "post" : "Accounts Receivable",
            "date" : "JUL 2017 - DEC 2017",
            "company" : "PROMETHEUS BUSINESS OUTSOURCING PVT. LTD.",
            "descrition" : [
                "Calling American insurance companies to follow/receive the status of claims sent by provider clients.",
                "Perfectly folllowing daily updates & taking quick decisions.",
                "Claim submission, sending appropriate documents & letters for claim sanctioning were included in the process."
            ]
        },
        {
            "post" : "Junior Software Developer",
            "date" : "JAN 2018 - JUN 2019",
            "company" : "PIXELMARGIN SOFTWARE PVT LTD.",
            "descrition" : [
                "Designing professional websites using various builders.",
                "Plugin usage & plugin editing.",
                "Worked on static wordpress websites creation & maintenance & also fixing design issues in Concrete5 CMS"
            ]
        },
        {
            "post" : "Software Developer",
            "date" : "JUL 2019 - FEB 2020",
            "company" : "MUTEX TECHNOLOGIES PVT LTD.",
            "descrition" : [
                "Working in MVC Codeigniter & CMS Wordpress.",
                "UI Developing & Android development.",
                "Solving design issues & implementing new functionalities.",
                "Worked multiple projects deducing UI problems & functionality dilemma."
            ]
        },
        {
            "post" : "Junior Software Engineer",
            "date" : "MAR 2020 - OCT 2020",
            "company" : "RSGP CONSULTING PVT LTD.",
            "descrition" : [
                "Worked in MVC Codeigniter & full stack web technologies in developing company dashboard.",
                "Module documentation, time estimation & from scratch to finish implementation of modules."
            ]
        },
        {
            "post" : "Software Developer",
            "date" : "DEC 2020 - Present",
            "company" : "EXCELLENCE CODE ADVERTISING L.L.C",
            "descrition" : [
                "Led the backend software development cycle for 4 main projects & multiple other projects.",
                "Projects were programmed in Codeigniter MVC & Wordpress CMS, with the use full stack web engineering.",
                "Built innovative CRM dashboards for academic & accounts managements.",
                "Ensuring security level of projects so that no breaching is done.",
                "Testing code in variable platforms & different ways.",
                "Documentation & requirement analysis of project modules & time manangement, code cleanliness for efficient, fast, sageness of the project.",
                "Spearheaded implementation of automation of documents to & from the system.",
                "Efficiently deployed and integrated projects in live servers & it’s maintanance"
            ]
        }
    ],
};